import { render, staticRenderFns } from "./MainWrapper.vue?vue&type=template&id=4a495882&scoped=true&"
import script from "./MainWrapper.vue?vue&type=script&lang=js&"
export * from "./MainWrapper.vue?vue&type=script&lang=js&"
import style0 from "./MainWrapper.vue?vue&type=style&index=0&id=4a495882&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a495882",
  null
  
)

export default component.exports